import { createClient } from '@supabase/supabase-js';

const url = process.env.REACT_APP_SUPABASE_URL;
const key = process.env.REACT_APP_SUPABASE_ANON_KEY;

let supabase = null;
try {
  if (url && key) {
    supabase = createClient(url, key);
  }
} catch (e) {
  console.warn('Supabase init failed:', e);
}

export { supabase };
